var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "projectsAccountModalRef",
          attrs: {
            id: "projectsAccountModalRef",
            "hide-footer": true,
            title: "Selecione um projeto para replicar os dados de Conta",
            size: "lg",
            "hide-header": false
          }
        },
        [
          _c("div", { staticClass: "modal-projects-list" }, [
            _vm.loadingProjects
              ? _c("div", [
                  _c("h6", [_vm._v("Aguarde, carregando projetos...")])
                ])
              : _c(
                  "ul",
                  _vm._l(_vm.projects, function(p) {
                    return _c("li", { key: p.ProjectId }, [
                      p.PagarmeAccount
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.selectProjectAccount(p)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(p.Info ? p.Info.title : "Sem Título")
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Código do Banco: " +
                                    _vm._s(p.PagarmeAccount.bankAccountCode) +
                                    " - Agência: " +
                                    _vm._s(
                                      p.PagarmeAccount.bankAccountAgency +
                                        "-" +
                                        p.PagarmeAccount.bankAccountAgencyDv
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Conta Corrente: " +
                                    _vm._s(
                                      p.PagarmeAccount.bankAccountAccount +
                                        "-" +
                                        p.PagarmeAccount.bankAccountAccountDv
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Titular: " +
                                    _vm._s(
                                      p.PagarmeAccount.bankAccountLegalName
                                    ) +
                                    " - CPF/CNPJ: " +
                                    _vm._s(
                                      p.PagarmeAccount.bankAccountDocumentNumber
                                    )
                                )
                              ])
                            ]
                          )
                        : _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.showAlert()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(p.Info ? p.Info.title : "Sem Título")
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Projeto não possui conta cadastrada.")
                              ])
                            ]
                          )
                    ])
                  }),
                  0
                )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.projects && _vm.projects.length > 0
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.projectsAccountModalRef",
                      modifiers: { projectsAccountModalRef: true }
                    }
                  ],
                  staticClass: "btn"
                },
                [_vm._v("Copiar de outro projeto")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("form", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Código do banco")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bankCode,
                      expression: "bankCode"
                    }
                  ],
                  staticClass: "form-control",
                  domProps: { value: _vm.bankCode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.bankCode = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm-4" }, [
                _c("label", [_vm._v("Agência")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.agency,
                      expression: "agency"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.agency },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.agency = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm-2" }, [
                _c("label", [_vm._v(" ")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.agencyCode,
                      expression: "agencyCode"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.agencyCode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.agencyCode = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm-4" }, [
                _c("label", [_vm._v("Conta Corrente")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.account,
                      expression: "account"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.account },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.account = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm-2" }, [
                _c("label", [_vm._v(" ")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.accountCode,
                      expression: "accountCode"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.accountCode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.accountCode = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "form-group col-sm-8" },
                [
                  _c("label", [_vm._v("Tipo de conta")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticClass: "mb-3",
                      model: {
                        value: _vm.accountType,
                        callback: function($$v) {
                          _vm.accountType = $$v
                        },
                        expression: "accountType"
                      }
                    },
                    [
                      _c("option", { attrs: { value: "conta_corrente" } }, [
                        _vm._v("Conta Corrente")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "conta_poupanca" } }, [
                        _vm._v("Conta Poupança")
                      ]),
                      _vm._v(" "),
                      _c(
                        "option",
                        { attrs: { value: "conta_corrente_conjunta" } },
                        [_vm._v("Conta Corrente conjunta")]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        { attrs: { value: "conta_poupanca_conjunta" } },
                        [_vm._v("Conta Poupança conjunta")]
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Nome do titular da conta")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.holder,
                      expression: "holder"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "30" },
                  domProps: { value: _vm.holder },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.holder = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("CNPJ da ONG")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "##.###.###/####-##",
                      expression: "'##.###.###/####-##'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cpfCnpj,
                      expression: "cpfCnpj"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Somente números" },
                  domProps: { value: _vm.cpfCnpj },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.cpfCnpj = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.save()
                }
              }
            },
            [_vm._v("Salvar dados bancários")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _vm.showMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.msg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSuccessMsg
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-success alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.successMsg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Transferência bancária")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Atenção: preenchimento obrigatório para recebimento de doações através de boleto bancário e cartões de crédito \n        (Doações realizadas através do PayPal serão creditadas diretamente na respectiva conta do PayPal da Organização Social)"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm" }, [
      _c(
        "a",
        {
          staticClass: "link-bank-codes",
          attrs: {
            href: "http://www.bcb.gov.br/pom/spb/estatistica/port/ASTR003.pdf",
            target: "_blank"
          }
        },
        [_vm._v("Pesquisar")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb834630", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb834630","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/BankInfo.vue
// module id = null
// module chunks = 